import {
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    GET_TYPING_USERS_REQUEST,
    SET_USERS,
    SET_USER,
    SUBMIT_USER_SUCCESS,
    SUBMIT_USER_REQUEST,
    SUBMIT_USER_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE
} from "../actions/users";
import { buildUsers } from "../helpers/users";
const initialState = {
    fetching: false,
    submitFetching: false,
    users: [],
    user: {},
    total: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_TYPING_USERS_REQUEST: {
            return {
                ...state,
                fetching: true,
                users: [],
                total: 0
            };
        }
        case GET_USERS_SUCCESS: {
            const isLoadingMoreItems = action.payload.page && action.payload.page > 1;
            
            const updatedUsers = isLoadingMoreItems
                ? [...state.users, ...buildUsers(action.payload.users, action.payload.profiles)]
                : buildUsers(action.payload.users, action.payload.profiles);
            
            return {
                ...state,
                fetching: false,
                users: updatedUsers,
                total: action.payload.total === 0 ? state.total : action.payload.total
            };
        }
        case GET_USERS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_USERS: {
            return {
                ...state,
                users: action.payload.users,
                total: action.payload.total
            };
        }
        case SET_USER: {
            return {
                ...state,
                user: action.payload.user
            };
        }

        case SUBMIT_USER_REQUEST: {
            return {
                ...state,
                submitFetching: true
            };
        }
        case SUBMIT_USER_SUCCESS: {
            return {
                ...state,
                submitFetching: false
            };
        }
        case SUBMIT_USER_FAILURE: {
            return {
                ...state,
                submitFetching: false
            };
        }

        case UPDATE_USER_REQUEST: {
            return {
                ...state,
                submitFetching: true
            };
        }
        case UPDATE_USER_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                user: action.payload.user
            };
        }
        case UPDATE_USER_FAILURE: {
            return {
                ...state,
                submitFetching: false
            };
        }

        default:
            return state;
    }
};
